import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=6b09d42c&scoped=true"
import script from "./rejectDialog.vue?vue&type=script&lang=js"
export * from "./rejectDialog.vue?vue&type=script&lang=js"
import style0 from "./rejectDialog.vue?vue&type=style&index=0&id=6b09d42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b09d42c",
  null
  
)

export default component.exports